<template>
  <div class="tusd-wrap wrap-bg header-scroll">
    <div class="page-title">我的</div>
    <cube-scroll>
      <div class="mine-info clearfix">
        <div class="clearfix">
          <div class="mine-header">
            <img :src="headimg" alt />
          </div>
          <div class="info-details">
            <div class="user-id">UID:{{changeUid(userInfo.UserID)}}</div>
            <div class="user-name">{{userInfo.Email}}</div>
            <div class="use-time">
              已在钱包平台
              <span>{{totalInfo.AllDay}}</span>天，已是王者玩家哦~
            </div>
          </div>
        </div>
        
        <div class="trade-comment clearfix">
            <div class="user-trade">
              <span>{{totalInfo.TotalTrade}}</span>
              <br />交易
            </div>
            <div class="user-comment">
              <span>{{totalInfo.ConfirmTime}}</span>
              <span class="unit">分钟</span>
              <br />平均确认时间
            </div>
          </div>
       <!--    <div class="trade-comment clearfix">
            <div class="user-trade">
              <span>{{totalInfo.ServiceTimeStart+':00' + ' - ' + totalInfo.ServiceTimeEnd+':00'}}</span>
              <br />个人接单时间
            </div>
            <div class="user-comment">
              <span>{{totalInfo.SystemServiceTimeStart+':00' + ' - ' + totalInfo.SystemServiceTimeEnd+':00'}}</span>
              <span class="unit"></span>
              <br />平台服务时间
            </div>
          </div>-->
        <div class="mine-setting" @click="goPage('setting')"></div>
      </div>
      <div class="separator"></div>
      <div class="mine-operation">
        <!-- <div class="box-wrap box-wrap-mine">
    			<div class="operation-item" @click="shareUrl">
    				<i class="operation-icon invite"></i>
    				<span>邀请好友</span>
    				<i class="more-icon"></i>
    			</div>
    			<div class="operation-item" @click="goPage('copartner')">
    				<i class="operation-icon partner"></i>
    				<span>我的合伙人</span>
    				<i class="more-icon"></i>
    			</div>
        </div>-->
        <div class="box-wrap box-wrap-mine">
          <div class="operation-item operation-item-switch" >
            <span>开始接单</span>
            <cube-switch v-model="orderSwitch" @input="changeSwitch">
              {{ orderSwitch?'开启':'关闭'  }}
            </cube-switch>
          </div>
        </div>
        <div class="box-wrap box-wrap-mine">
          <!-- <div class="operation-item" @click="goPage('auth')">
    				<i class="operation-icon auth"></i>
    				<span>实名认证</span>
    				<i class="more-icon"></i>
          </div>-->
          <div class="operation-item" @click="goPage('accounts')">
            <i class="operation-icon account"></i>
            <span>收款账号</span>
            <i class="more-icon"></i>
          </div>
          <div class="operation-item" @click="goPage('reset')">
            <i class="operation-icon password"></i>
            <span>修改密码</span>
            <i class="more-icon"></i>
          </div>
          <!-- <div class="operation-item">
    				<i class="operation-icon service"></i>
    				<span>联系客服</span>
    				<i class="more-icon"></i>
          </div>-->
        </div>
        <!-- <div class="box-wrap box-wrap-mine">
          <div class="operation-item" @click="shareUrl">
            <i class="operation-icon invite"></i>
            <span>邀请好友</span>
            <i class="more-icon"></i>
          </div>
          
        </div> -->
      </div>
    </cube-scroll>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "mine",
  data() {
    return {
      headimg: _defaultimg_,
      totalInfo: {
        ServiceTimeStart:0,
        ServiceTimeEnd:0,
        SystemServiceTimeStart:0,
        SystemServiceTimeEnd:0,

      },
      orderSwitch:false,
      orderSwitchData:true
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  mounted() {},
  methods: {
    getUserGeneral() {
      this.$api.getUserGeneral().then(res => {
        this.totalInfo = res.data;
        this.orderSwitch = this.totalInfo.StopTrade == 1 ? false : true
        this.orderSwitchData = this.orderSwitch
      });
    },
    shareUrl() {
      let name = "banner",
        url = this.$store.state.userInfo.shareUrl;
      this.$router.push({
        name: name,
        params: {
          url: url,
          title: "邀请好友"
        }
      });
    },
    goPage(name) {
      if (name === "copartner") {
        //如果是合伙人则弹出提示下个版本支持
        that.$message.popup("下一个版本支持，敬请期待", 1000);
        return false;
      }
      let params = {
        name: name,
        back: "mine"
      };
      if (name == "setting") {
        params = Object.assign(params, {
          headImgUrl: this.userInfo.headImgUrl,
          nickName: this.userInfo.nickName
        });
      }
      this.$store.commit("storeParams", params);
      this.$router.push({ name: name });
    },
    changeSwitch(value){
      if(this.orderSwitchData == value){
        return false
      }else{
        this.changeOrderSwitch(value)
      }
      
    },
    changeOrderSwitch(value){
      var status = value ?  0 : 1
      this.$api.changeOrderSwitch(status).then(res => {
          this.$message.popup(res.msg, 1000);
          this.orderSwitchData = value
          this.getUserGeneral()
      }).catch(res => {
          this.$message.popup(res.msg, 1000);
          this.orderSwitchData = !value
          this.orderSwitch = !value
      });
    },
    changeUid(value){
      if(value){
        return 10000+parseInt(value)
      }else{
        return 0
      }
    }
  },
  created() {
    if (this.$store.state.userInfo.HeadImageUrl) {
      if (this.$store.state.needLoad) {
        this.headimg =
          this.$store.state.userInfo.HeadImageUrl + "?t=" + +new Date();
      } else {
        this.headimg = this.$store.state.userInfo.HeadImageUrl;
      }
    }
    this.getUserGeneral();
  }
};
</script>

<style lang="less" scoped>
.mine-info {
  padding: 20px;
  .mine-header {
    float: left;
    width: 64px;
    height: 64px;
    border-radius: 100%;
    overflow: hidden;
    background: url(../assets/images/header.png) center center no-repeat;
    background-size: cover;
    img {
      width: 100%;
    }
  }
  .info-details {
    float: left;
    margin: 10px 0px 0px 16px;
    .user-name {
      margin-bottom: 10px;
      font-size: 17px !important;
      color: #d9e3fd;
    }
    .user-id {
      color: #909fe1;
      font-size: 12px !important;
      margin-bottom: 10px;
    }
    .use-time {
      color: #5f6893;
      font-size: 12px !important;
      span {
        color: #909fe1;
      }
    }
    
  }
  .trade-comment {
      margin-top: 24px;
      text-align: center;
      width: 100%;
      display: flex;
      span {
        display: inline-block;
        margin-bottom: 6px;
        color: #28faff;
        font-size: 24px !important;
      }
      .user-trade {
        float: left;
        color: #96abe4;
        width: 50%;
      }
      .user-comment {
        float: right;
        color: #96abe4;
        width: 50%;
        span.unit {
          margin-left: 5px;
          color: #5f6893;
          font-size: 12px !important;
        }
      }
    }
  .mine-setting {
    float: right;
    width: 30px;
    height: 30px;
    margin-top: 10px;
    background: url(../assets/images/setting.svg) center center no-repeat;
    background-size: 70%;
  }
}
.mine-operation {
  padding: 16px @space;
  .box-wrap {
    .operation-item {
      line-height: 50px;
      .operation-icon {
        display: inline-block;
        vertical-align: middle;
        width: 34px;
        height: 34px;
        margin-right: 14px;
        background: center center no-repeat;
        background-color: #2f365c;
        background-size: 66%;
        border-radius: 50%;
        &.invite {
          background-image: url(../assets/images/invite.svg);
        }
        &.partner {
          background-image: url(../assets/images/partner.svg);
          background-size: 50%;
        }
        &.auth {
          background-image: url(../assets/images/auth.svg);
          background-size: 50%;
        }
        &.account {
          background-image: url(../assets/images/account.svg);
          background-size: 54%;
        }
        &.password {
          background-image: url(../assets/images/password.svg);
          background-size: 64%;
        }
        &.service {
          background-image: url(../assets/images/service.svg);
          background-size: 52%;
        }
      }
      span {
        display: inline-block;
        vertical-align: middle;
        font-size: 16px !important;
        color: #d9e3fd;
      }
      .more-icon {
        float: right;
        width: 18px;
        height: 18px;
        margin-top: 16px;
        background: url(../assets/images/more.svg) center center no-repeat;
      }
      & + .operation-item {
        border-top: 1px solid #4d567f;
      }
    }
    & + .box-wrap {
      margin-top: @space;
    }
  }
}
.operation-item-switch{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  
}
@media screen and (max-width: 370px) {
  .mine-info {
    padding: 15px 12px;
    .mine-header {
      width: 52px;
      height: 52px;
    }
    .info-details {
      margin-left: 10px;
    }
    .mine-setting {
      width: 26px;
      height: 26px;
    }
  }
}
</style>